import {
  faChartLine,
  faRightLeft,
  faTableCellsLarge,
  faTimeline,
  faUser
} from '@fortawesome/free-solid-svg-icons';

export const links = [
  { title: 'Trading', path: '/', icon: faChartLine },
  { title: 'Swap', /*path: '/swap',*/ icon: faRightLeft },
  { title: 'Pools', icon: faTableCellsLarge },
  { title: 'Governance', icon: faTimeline },
  { title: 'Me', path: '/assets', icon: faUser, mobileOnly: true }
];

export const Logo = new URL('../../image/EX3_W_H.svg', import.meta.url) + '';

export const NFT_GaGa =
  new URL('../../image/nftgaga.png', import.meta.url) + '';
